import gql from "graphql-tag";

export default gql`
  query getAutosuggest($search: String!, $first: Int!) {
    autoSuggest: autoSuggest(search: $search, first: $first)
  }
`;
